export default __webpack_public_path__ + "static/media/case-picnic2.198b68bd.png";